import React, { useContext } from 'react';

import {

    makeStyles, TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Card, CardContent
} from '@material-ui/core';
import { v4 as uuid } from 'uuid';

import UserContext from '../../context/Globales/UserContext';
import PerfectScrollbar from 'react-perfect-scrollbar';
import  { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '10px',
        fontWeight: '250',
        fontSize: '16px'
    },
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main,
        minWidth: 200,
        color: 'white',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },
    tableRow: {
        cursor: 'pointer',
      },
      tableRowHover: {
        '&:hover': {
          backgroundColor: theme.palette.grey[200],
          fontWeight: 'bold',
          boxShadow : '60px -6px 0',
          cursor: 'pointer'
          
        },
      },
    fondoTituloIndicadores: {

        backgroundColor: theme.palette.fondotitulos.main,
        minWidth: 200,
        color: '#171717',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },


    FondoTable: {

        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
    },
    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
    },

    TblSize: {

        maxHeight: 'auto',
        maxWidth: '100%'
    },

    TblSizeMobile:{
        maxHeight: '350px',
        maxWidth: '100%'
    }
}));


const TblEstructuraFinanciera = () => {




    const classes = useStyles();
    const { dataDetalleEstructura } = useContext(UserContext)

    function number_format(amount, decimals) {

        amount += ''; // por si pasan un numero en vez de un string
        amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

        decimals = decimals || 0; // por si la variable no fue fue pasada

        // si no es un numero o es igual a cero retorno el mismo cero
        if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

        // si es mayor o menor que cero retorno el valor formateado como numero
        amount = '' + amount.toFixed(decimals);

        var amount_parts = amount.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');

        return amount_parts.join('.');
    }
 
    const SaludarDesdeTable = ()=> {
        alert('Soy el evento moMouseOver');
    }

    return (
        <div>
            {dataDetalleEstructura && dataDetalleEstructura.length > 0 ? (
                <Card>
                    <CardContent>



                        <TableContainer className={ isMobile ?  classes.TblSizeMobile : classes.TblSize}>
                            <PerfectScrollbar>

                                <Table stickyHeader aria-label="sticky table" size="small" >

                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan="13" className={classes.fondoTituloIndicadores}>Detalle Estructura Financiera </TableCell>
                                        </TableRow>
                                        {dataDetalleEstructura.slice(0, 1).map((c, id) => (
                                            <TableRow style={{ backgroundColor: '#dedfe3' }} key={id}>

                                                <>
                                                    <TableCell style={{ width: '30%', textAlign: 'center' }}  ><strong>Descripción</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo1Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo2Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo3Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo4Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo5Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo6Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo7Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo8Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo9Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '6%', textAlign: 'center' }}><strong>{c.Periodo10Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '5%', textAlign: 'center' }}><strong>{c.Periodo11Nombre}</strong></TableCell>
                                                    <TableCell style={{ width: '5%', textAlign: 'center' }}><strong>{c.Periodo12Nombre}</strong></TableCell>
                                                </>

                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody  >
                                        {dataDetalleEstructura.map((cbody, idd) => (
                                            <TableRow key={idd + 1} className={classes.tableRowHover}>

                                                <TableCell  style={{ backgroundColor: '#eeeeee', width: '30%', borderBottom: '0.5px solid #a7a7a8 ', borderTop: '0.5px solid #a7a7a8', bordeLet: '0.5px solid #a7a7a8', borderRight: '0.5px solid #a7a7a8', fontWeight: 'bold' }} >{cbody.Concepto}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo1Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo2Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo3Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo4Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo5Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo6Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo7Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo8Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo9Valor)}</TableCell>
                                                <TableCell  style={{ width: '6%', textAlign: 'right' }}>{number_format(cbody.Periodo10Valor)}</TableCell>
                                                <TableCell  style={{ width: '5%', textAlign: 'right' }}>{number_format(cbody.Periodo11Valor)}</TableCell>
                                                <TableCell  style={{ width: '5%', textAlign: 'right' }}>{number_format(cbody.Periodo12Valor)}</TableCell>

                                            </TableRow>
                                        ))}

                                    </TableBody>

                                </Table>

                            </PerfectScrollbar>
                        </TableContainer>



                    </CardContent>
                </Card>
            ) : ''}

        </div>
    )
}

export default TblEstructuraFinanciera;

